export default __webpack_public_path__ + "static/media/logo.af10d63e.png";